import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withKeys as _withKeys, createTextVNode as _createTextVNode, withModifiers as _withModifiers, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3a2c85d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login-container" }
const _hoisted_2 = { class: "form-container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-container" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "title-logo" }),
  /*#__PURE__*/_createElementVNode("div", { class: "logo-text" }, "LPOA-金马证劵有限公司")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "login-title" }, "登录", -1))
const _hoisted_5 = { class: "rem-psd" }
const _hoisted_6 = { class: "compliance" }
const _hoisted_7 = ["href"]
const _hoisted_8 = ["href"]
const _hoisted_9 = ["href"]
const _hoisted_10 = ["href"]
const _hoisted_11 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_messagePop = _resolveComponent("messagePop")!
  const _component_changePwd = _resolveComponent("changePwd")!
  const _component_PromptDialog = _resolveComponent("PromptDialog")!
  const _component_RevisePwd = _resolveComponent("RevisePwd")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_form, {
          ref: "loginFormRef",
          model: _ctx.loginForm,
          rules: _ctx.rules,
          class: "login-form custom-class",
          autocomplete: "on",
          "label-position": "left"
        }, {
          default: _withCtx(() => [
            _hoisted_3,
            _hoisted_4,
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  ref: "userNameRef",
                  modelValue: _ctx.loginForm.username,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.loginForm.username) = $event)),
                  placeholder: "请输入用户名",
                  name: "username",
                  type: "text",
                  tabindex: "1",
                  "prefix-icon": _ctx.User
                }, null, 8, ["modelValue", "prefix-icon"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_tooltip, {
              modelValue: _ctx.capsTooltip,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.capsTooltip) = $event)),
              content: "Caps lock is On",
              placement: "right",
              manual: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      key: "password",
                      ref: "passwordRef",
                      modelValue: _ctx.loginForm.password,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.loginForm.password) = $event)),
                      placeholder: "请输入密码",
                      name: "password",
                      "show-password": "",
                      tabindex: "2",
                      autocomplete: "on",
                      onKeyup: [
                        _ctx.checkCapslock,
                        _cache[3] || (_cache[3] = _withKeys(($event: any) => (_ctx.handleLogin(_ctx.loginFormRef)), ["enter"]))
                      ],
                      onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.capsTooltip = false)),
                      "prefix-icon": _ctx.Lock
                    }, null, 8, ["modelValue", "onKeyup", "prefix-icon"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", {
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.showPwdDialog && _ctx.showPwdDialog(...args)))
              }, "忘记密码")
            ]),
            _createVNode(_component_el_button, {
              class: "login-btn",
              loading: _ctx.loading,
              type: "primary",
              onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.handleLogin(_ctx.loginFormRef)), ["prevent"]))
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 登录 ")
              ]),
              _: 1
            }, 8, ["loading"]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_el_checkbox, {
                name: "阅读并同意",
                class: "compliance-checkbox",
                modelValue: _ctx.compliance,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.compliance) = $event)),
                label: "阅读并同意",
                size: "large",
                style: {"border-radius":"50%"}
              }, null, 8, ["modelValue"]),
              _createElementVNode("a", {
                class: "compliance-a",
                target: "_blank",
                href: _ctx.DEFAULT_CONFIG.LOGIN_PERSON_INFO_URL
              }, "《个人资料收集声明》", 8, _hoisted_7),
              _createElementVNode("a", {
                class: "compliance-a",
                target: "_blank",
                href: _ctx.DEFAULT_CONFIG.LOGIN_APPLICATION_URL
              }, "《流动程式使用条款》", 8, _hoisted_8),
              _createElementVNode("a", {
                class: "compliance-a",
                target: "_blank",
                href: _ctx.DEFAULT_CONFIG.LOGIN_DISCLAIMER_URL
              }, "《免责声明》", 8, _hoisted_9),
              _createElementVNode("a", {
                class: "compliance-a",
                target: "_blank",
                href: _ctx.DEFAULT_CONFIG.LOGIN_PRIVACY_URL
              }, "《私隐政策》", 8, _hoisted_10),
              _createTextVNode("和"),
              _createElementVNode("a", {
                class: "compliance-a",
                target: "_blank",
                href: _ctx.DEFAULT_CONFIG.LOGIN_ELECTRONIC_TRANSACTION_URL
              }, "《电子交易条款》", 8, _hoisted_11)
            ])
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _createVNode(_component_messagePop, {
        dialogVisible: _ctx.confirmPopupFlag,
        "onUpdate:dialogVisible": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.confirmPopupFlag) = $event)),
        phoneMessage: _ctx.phoneMessage
      }, null, 8, ["dialogVisible", "phoneMessage"]),
      _createVNode(_component_changePwd, {
        dialogVisible: _ctx.pwdDialog,
        "onUpdate:dialogVisible": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.pwdDialog) = $event))
      }, null, 8, ["dialogVisible"]),
      _createVNode(_component_PromptDialog, {
        dialogVisible: _ctx.promptDialog,
        "onUpdate:dialogVisible": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.promptDialog) = $event)),
        onConfirm: _ctx.toRevise
      }, null, 8, ["dialogVisible", "onConfirm"])
    ]),
    _createVNode(_component_RevisePwd, {
      dialogVisible: _ctx.revisePwdDialog,
      "onUpdate:dialogVisible": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.revisePwdDialog) = $event)),
      managerId: _ctx.loginForm.username,
      clientId: 'dmz'
    }, null, 8, ["dialogVisible", "managerId"])
  ], 64))
}